export const buildShortlistFilters = ({
  currentBedrooms,
  currentBathrooms,
  currentMinPrice,
  currentMaxPrice,
  minPriceSelected,
  maxPriceSelected,
  currentType,
  currentLandlord,
  useExactRoomCounts,
} = {}) => ({
  bedrooms: currentBedrooms,
  bathrooms: currentBathrooms,
  minPrice: currentMinPrice,
  maxPrice: currentMaxPrice,
  minPriceSelected,
  maxPriceSelected,
  type: currentType,
  lettingAgent: currentLandlord?.obfuscatedId || currentLandlord,
  useExactRoomCounts,
});

export const getFilteredShortlist = ({ store, filters } = {}) => {
  const shortlist = Array.isArray(store?.shortlist) ? store.shortlist : [];

  if (typeof store?.filterShortlist === 'function') {
    const filtered = store.filterShortlist(filters || {});
    return Array.isArray(filtered) ? filtered : [];
  }

  return shortlist;
};
